import { Component, ViewChild, Injectable, ChangeDetectorRef, OnInit } from '@angular/core';
import { MsgTemplateEdit } from '../../msg-interface/msg-template-edit';
import { _MSGTYPES } from '../../shared/constant/msgType';
import { URLS } from '../../shared/constant/interface';
import { FormGroup } from '@angular/forms';
import { ModalHelper } from '@delon/theme';
import { DialogService, IccPatchDialogComponent, PermissionControlService, tagSelect, TemplateService, varSelect } from 'mmmo-mo-common-lib';
import { deepCopy } from '@delon/util';
import { TemplateEditData } from '../../msg-interface/data-model';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-voice-tpl-edit',
  templateUrl: './voice-tpl-edit.component.html',
  styles: [
    `
      :host .add-btn {
        height: 32px;
        padding: 0 15px;
        line-height: 32px;
        background: #fff;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        transition: all 0.5s;
        cursor: pointer;
        margin-right: 10px;
      }
      .add-btn:hover {
        background: #fff;
        border: 1px dashed #37ba9d;
        color: #37ba9d;
      }
    `,
  ],
})
export class VoiceTplEditComponent implements MsgTemplateEdit, OnInit {
  SCENE = 'icc-msg-tpl-edit';
  /** 数据源 */
  source: TemplateEditData = {};

  /** 辅助 --消息类型 */
  _MSGTYPES = _MSGTYPES;
  type = _MSGTYPES.MT.VOICE.type;

  /** 辅助 -- 模板内容最大字数 */
  maxLength = 500;

  /** 重要 -- 新增的空白模板 */
  standardTemplate = {
    id: 0,
    name: '',
    priority: null,
    msgType: this.type,
    bizTypeId: this.source.id,
    mediaList: [],
    contentType: null,
    content: '',
    title: null,
    copyValue: 0,
    operateType: '1',
    isDefault: false,
    editIndex: -1,
    conditions: [],
    vIndex: 0,
    patchStrategy: [],
  };
  @ViewChild('form', { static: false }) form: FormGroup;

  isHasPaster = true;

  isPassPattern = true;
  isValidContent = true;

  constructor(private permissionControl: PermissionControlService, private templateService: TemplateService, private dialogService: DialogService, private modal: ModalHelper, private cdr: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.isHasPaster = !this.permissionControl.getLimitByField('patch');
  }

  // ============================= STRAT 接口实现 ============================= //
  setFormData(data: any): void {
    const { templates = [] } = data;
    this.processTemplate(templates);
    this.source = data;
  }
  getData() {
    return this.source.templates;
  }
  validate(): boolean {
    let result = true;
    const { useTmplMethod, templates } = this.source;

    // ----- 全局校验 -----
    if (Number(useTmplMethod) === 1 && !this.templateService.hasDefaultTpl(this.type)) {
      this.dialogService.notification.error('语音模板', '模板形式为【智能模板 】时，每种消息类型必须要有一个默认模板');
      return false;
    }

    if (Number(useTmplMethod) === 2 && templates.length < 1) {
      this.dialogService.notification.error('语音模板', '模板形式为【普通模板】时，必须要有一个模板');
      return false;
    }

    // ----- 表单校验 -----
    if (templates.length > 0) {
      this.cleanupDirty();

      const inValid = templates.some(item => {
        if (!item.valid || !item.name) {
          this.dialogService.notification.error('语音模板', '语音模板名称不能为空，不能重复');
          return true;
        }
        if (!item.content) {
          this.dialogService.notification.error('语音模板', '语音模板内容不能为空');
          return true;
        }

        // 忽略插入贴片的特殊符号
        let tempContent = item.content;
        if (item.patchStrategy && item.patchStrategy.length > 0) {
          for (let i = 0, len = item.patchStrategy.length; i < len; i++) {
            const groupName = item.patchStrategy[i].groupName;
            tempContent = tempContent.replace(new RegExp('\\${' + groupName + '}', 'g'), '');
          }
        }
        // 忽略插入变量的特殊符号
        if (this.source.variableBinds && this.source.variableBinds.length > 0) {
          const variableBinds = this.source.variableBinds;
          for (let i = 0, len = variableBinds.length; i < len; i++) {
            const code = variableBinds[i].code;
            tempContent = tempContent.replace(new RegExp('\\${' + code + '}', 'g'), '');
          }
        }

        const pattern = /[^\u4e00-\u9fa5a-zA-Z\d\，，,。""“”《》！!?？]+/;

        if (pattern.test(tempContent)) {
          this.dialogService.notification.error('语音模板', '为了语音能正常播报，请勿输入除逗号、句号、双引号、书名号、感叹号、问号之外的特殊符号。');
          return true;
        }

        if (!item.isDefault && item.conditions && !item.conditions.value && Number(useTmplMethod) === 1) {
          if (item.conditions.length === 0) {
            this.dialogService.notification.error('语音模板', '非默认模板至少要添加一条执行条件！');
            return true;
          } else if (item.conditions.some(it => it.isEdit)) {
            this.dialogService.notification.error('语音模板', '请确保执行条件已经保存！');
            return true;
          }
        }
      });

      if (this.form.invalid) {
        this.dialogService.notification.error('语音模板', '语音模板格式有误！');
        return false;
      }

      if (inValid) result = false;
    }
    return result;
  }
  // ============================= END 接口实现 ============================= //

  // ============================= START 辅助方法 ============================= //

  /** 添加一些辅助的字段 */
  processTemplate(template: any, isNew: boolean = false) {
    if (template) {
      const _temp = isNew ? [...template] : template;
      _temp.forEach((item, index) => {
        item.valid = true; // 是否是有效的模板名称
        item.vIndex = item.content ? item.content.length : 0; // content光标的位置
        item.copyValue = 0; // 复用了哪一个模板
        item.htmlId = isNew ? `msgType${this.type}${this.source.templates.length}` : `msgType${this.type}${index}`; // 标识符
      });
    }
  }

  /** 模板增加后的回调 */
  updateHandle() {
    const target = this.templateService.getLastTpl(this.type);
    this.processTemplate(target, true);
  }
  /** 复用操作 */
  copyHandle(template: any, index: number) {
    let { content, title, conditions, operateType, htmlId, patchStrategy } = deepCopy(template);
    content = content.length > this.maxLength ? content.substr(0, this.maxLength) : content;

    if (conditions) {
      conditions.forEach(it => {
        it.type = it.type.value === tagSelect.value ? tagSelect : varSelect;
      });
    } else {
      conditions = [];
    }
    const _t = deepCopy(this.source.templates[index]);
    _t.content = content;
    _t.title = title;
    _t.conditions = conditions;
    _t.operateType = operateType;
    _t.copyValue = htmlId;
    _t.patchStrategy = patchStrategy;
    this.source.templates[index] = deepCopy(_t);
    // 更新视图
    this.cdr.detectChanges();
    this.cleanupDirty();
  }
  /** 手动驱动校验 */
  cleanupDirty() {
    setTimeout(() => {
      // tslint:disable-next-line: forin
      for (let a in this.form.controls) {
        this.form.controls[a].markAsDirty();
        this.form.controls[a].updateValueAndValidity();
      }
    }, 100);
  }

  // ============================= END 辅助方法 ============================= //

  /**
   * 插入业务变量 （通过光标位置进行插值）
   * @param value 传入的变量值
   * @param template 模板对象
   */
  insertVar(value, index: any): void {
    // 微信跳过
    if (this.type === this._MSGTYPES.MT.WECHAT.type) return;

    const temp = deepCopy(this.source.templates[index]);
    let { content, vIndex } = temp;
    let aPart = content.slice(0, vIndex);
    let bPart = content.slice(vIndex);
    temp.content = aPart + '${' + value.code + '}' + bPart;
    temp.vIndex = content.length + value.code.length + 3;
    this.source.templates[index] = deepCopy(temp);
    this.cdr.detectChanges();
  }

  // TODO: 根据不同的消息类型，进行特定的copy
  /**
   * 设置光标的位置
   * @param event 点击事件
   * @param template 模板对象
   */
  setCursorPositionByEvent(event, template: any): void {
    let field = event.target;
    template.vIndex = field.selectionStart;
  }

  setCursorOffset($event, template: any): void {
    template.vIndex = $event;
  }

  /** 贴片选择弹窗 */
  openPatchModal(template: any, contentType) {
    if (!this.checkPatch(template.patchStrategy)) return;
    this.modal
      .create(
        IccPatchDialogComponent,
        {
          msgType: template.msgType,
          contentType,
          groupUrl: URLS.templatePatchGroup.url,
          itemUrl: URLS.templatePatchGroupItem.url,
          content: template.content,
        },
        {
          size: 'lg',
        },
      )
      .subscribe(result => this.afterHandleForPatchSelected(template, result));
  }

  /** 贴片选择后处理 */
  afterHandleForPatchSelected(template, result) {
    if (template.patchStrategy) {
      // template.patchStrategy.push(result);
      template.patchStrategy = [...template.patchStrategy, result];
    } else {
      template.patchStrategy = [result];
    }
    template.content = template.content.slice(0, template.vIndex) + '${' + result.groupName + '}' + template.content.slice(template.vIndex);
    template.vIndex = template.vIndex + result.groupName.length + 3;
  }

  /** 贴片检测 */
  checkPatch(patchStrategy: any[]): boolean {
    if (patchStrategy && patchStrategy.length >= 3) {
      this.dialogService.notification.warning('注意', `最多只能添加三个贴片`);
      return false;
    }
    return true;
  }
  /** 监听文本框的输入 */
  inputChange(template: any) {
    const { content, patchStrategy } = template;
    if (patchStrategy) {
      template.patchStrategy = patchStrategy.filter(v => {
        return content.indexOf('${' + v.groupName + '}') > -1;
      });
    }
  }

  // 监听 fake-textarea 输入事件监听
  handelValueChange($event, template) {
    const { patchStrategy } = template;
    // template中的value 与 faketextarea中的value同步
    template.content = $event.replace(/ /g, '');

    // const pattern = /[^\u4e00-\u9fa5a-zA-Z\d\，，,。""“”《》！!?？]+/;

    // this.isPassPattern = !pattern.test(template.content);
    // this.isValidContent = this.isPassPattern && template.content && template.content.length <= this.maxLength;

    // 根据 content中的值，动态删除多余的 pasters
    if (patchStrategy) {
      template.patchStrategy = patchStrategy.filter(v => {
        return template.content.indexOf('${' + v.groupName + '}') > -1;
      });
    }
    this.cdr.detectChanges();
  }
}
